<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showAttachedDocs"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <div
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full"
        >
          <!-- HEADER -->
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Attachments</p>
            <img
              class="h-6 cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close"
            />
          </div>

          <!-- EXISTING ATTACHMENT CARD -->
          <div class="grid grid-cols-2 p-4 gap-5">
            <DocumentsDisplay
              :delete-document-callback="deleteDocument"
              :document="{
                url: info.Attachment.trim(),
                DocumentType: 'Review Attachment',
              }"
              :openPDFViewer="openPDFViewer"
            />
          </div>

          <!-- UPLOAD -->
          <div
            class="flex flex-col items-center m-4 p-4 border-1.5 border-dashed rounded-md cursor-pointer"
          >
            <label for="fileInput" class="text-gray-500">
              <i class="fas fa-cloud-upload-alt text-3xl mb-2"></i>
              <p>Click or drag to upload</p>
            </label>
            <input
              type="file"
              id="fileInput"
              class="hidden"
              @change="handleFileUpload"
            />
            <p class="text-sm text-gray-500">
              Uploading a new attachment will override the existing one.
            </p>
          </div>
        </div>
      </div>
    </transition>

    <!-- VIEWER -->
    <AttachmentsViewer
      :showAttachments="showAttachments"
      :attachmentUrl="attachmentUrl"
      :attachmentType="attachmentUrl"
      :docTitle="docTitle"
      @close="showAttachments = false"
    />
  </div>
</template>

<script>
import AttachmentsViewer from '@/utils/attachmentsViewer.vue';
import DocumentsDisplay from '@/utils/documentsDisplay.vue';
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  name: 'ShowAttachedDocs',

  components: { DocumentsDisplay, AttachmentsViewer },

  props: ['showAttachedDocs', 'info'],

  data() {
    return {
      showAttachments: false,
      attachmentUrl: '', // 🔥 direct URL, no blob
      docTitle: '',
    };
  },

  created() {
    this.attachmentUrl = this.info.Attachment?.trim() || '';
  },

  computed: {
    ...mapGetters([
      'getOrganization',
      'getToken',
      'getTabTitle',
      'getCurrentEmployeeId',
    ]),
  },

  methods: {
    close() {
      this.$emit('close');
    },

    /** 🔥 NO MORE BLOB / NO FETCH / NO BASE64 — JUST OPEN DIRECT URL */
    openPDFViewer(documentUrl, title = 'Review Attachment') {
      this.attachmentUrl = documentUrl; // direct absolute URL (https://api/file/xxxx)
      this.docTitle = title;
      this.showAttachments = true;
    },

    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.loading = true;
      const formData = new FormData();
      formData.append('file', file);

      const uploadUrl = `${this.getOrganization}/upload`;

      axios
        .post(uploadUrl, formData, {
          headers: { Authorization: `Bearer ${this.getToken}` },
        })
        .then((response) => {
          this.loading = false;
          if (response.status === 200) {
            this.attachmentUrl = response.data.url;
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error('File upload failed:', error);
        });
    },

    deleteDocument(employeeDocumentId) {
      this.loading = true;
      const options = {
        headers: { Authorization: `Bearer ${this.getToken}` },
      };

      axios
        .delete(
          `${this.getOrganization}/employee/document/${employeeDocumentId}/v1/delete`,
          options
        )
        .then((response) => {
          this.loading = false;
          if (response.data.StatusCode === 200) {
            this.$emit('reload');
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error(error);
        });
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
